import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "whiteCaret",
  "use": "whiteCaret-usage",
  "viewBox": "0 0 9 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 7\" id=\"whiteCaret\">\n  <path fill=\"#f2f2ed\" d=\"M7.8 1L4.6 5.5 1.4 1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol